import React from 'react';
import { useBlog } from '../../context/BlogContext';

export default function MediaGrid() {
  const { media, deleteMedia } = useBlog();

  const copyUrl = (url) => {
    navigator.clipboard.writeText(url).catch(() => {});
  };

  if (!media.length) {
    return <p className="adminblog-no-posts">No media files yet. Upload images above.</p>;
  }

  return (
    <div className="adminblog-media-grid">
      {media.map(item => (
        <div key={item.id} className="adminblog-media-item">
          {item.type === 'video' ? (
            <video src={item.url} muted playsInline preload="metadata" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <img src={item.url} alt={item.filename || 'media'} />
          )}
          <div className="adminblog-media-overlay">
            <button className="adminblog-media-action" onClick={() => copyUrl(item.url)}>Copy URL</button>
            <button className="adminblog-media-action" onClick={() => deleteMedia(item.id)}>Delete</button>
          </div>
        </div>
      ))}
    </div>
  );
}
